import { AccountAside } from '@src/components/sco/Account/Layout/AccountAside';
import { AccountContextProvider } from '@src/components/sco/Account/Layout/AccountContext';
import { AccountNav } from '@src/components/sco/Account/Layout/AccountNav';
import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useAppContextStore } from '@src/contexts/AppContextStore';
import { usePathname } from 'next/navigation';
import React, { useMemo } from 'react';
type AccountLayoutProps = {
  asidePanel?: React.ReactNode;
  mainPanel?: React.ReactNode;
  navPanel?: React.ReactNode;
};
export const AccountLayout: React.FC<AccountLayoutProps> = props => {
  const {
    contextStore
  } = useAppContextStore();
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState(false);
  const pathname = usePathname();
  const panels: AppLayoutPanelProps[] = useMemo(() => [{
    id: 'account-nav',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'right',
    defaultWidth: 280,
    minWidth: 200,
    maxWidth: 400,
    children: props.navPanel ? props.navPanel : <AccountNav />,
    isPanelOpen: true,
    isDrawerOpen: false
  }, {
    id: 'account-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true
  }, {
    id: 'account-aside',
    useDrawerBreakpoints: {
      base: true,
      lg: false
    },
    isResizable: true,
    resizeHandlePosition: 'left',
    drawerPlacement: 'right',
    defaultWidth: 460,
    minWidth: 300,
    maxWidth: 600,
    children: props.asidePanel || <AccountAside />,
    isPanelOpen: asidePanelIsOpen,
    onPanelClose: () => {
      setAsidePanelIsOpen(false);
    },
    isDrawerOpen: false
  }], [pathname]);
  return <AccountContextProvider {...contextStore.getNamespace('AccountContext')}>
      <AppLayout header={<ScoSiteNavBar />} id={'Account-layout'} panels={panels} />
    </AccountContextProvider>;
};